import dayjs from 'dayjs';
import { aggregateAssignmentStats } from './aggregateAssignmentStats.util';

export const returnTotalUnitCompletionOfTaskFromChildren = (
  childTasks,
  assignmentStatsMap,
  allTasks = []
) => {
  const getTaskHours = (task) => {
    if (task.estimatedHours) {
      return Number(task.estimatedHours);
    }
    const days =
      dayjs(task.plannedEndDate).diff(dayjs(task.plannedStartDate), 'days') + 1;
    return days * 8;
  };

  const totalHours = childTasks.reduce((sum, child) => {
    return sum + getTaskHours(child);
  }, 0);

  const totalCompletion = childTasks.reduce((total, child) => {
    const childHours = getTaskHours(child);
    const weightRatio = childHours / totalHours;

    const { unitCompletionPercentage } = aggregateAssignmentStats(
      child,
      assignmentStatsMap,
      allTasks
    );

    const childUnitCompletion =
      unitCompletionPercentage !== null
        ? unitCompletionPercentage
        : Number(child.manualCompletionValue) || 0;

    const weightedCompletion = childUnitCompletion * weightRatio;
    return total + weightedCompletion;
  }, 0);

  return totalCompletion;
};
